import { Box, ListItem, ListItemText } from "@mui/material";
import { menuItem, menuItemContent, menuItemText } from "./Styles";

const MenuItem = ({ open, name, active }) => {
  return (
    <Box sx={{ px: 1, my: 0.3 }}>
      <ListItem sx={(theme) => menuItem(theme, { active: active, color: "red" })}>
        <Box
          sx={(theme) =>
            menuItemContent(theme, {
              active: active,
              //   miniSidenav,
              name: "Side Menu",
              //   open,
              //   nested,
            })
          }
        >
          <ListItemText
            primary={name}
            sx={(theme) =>
              menuItemText(theme, {
                //   active,
                //   miniSidenav,
                miniSidenav: !open,
                //   open,
                //   nested,
              })
            }
            // primaryTypographyProps={{
            //   style: {
            //     // color: "red",
            //     fontSize: pxToRem(14),
            //   },
            // }}
          />
        </Box>
      </ListItem>
    </Box>
  );
};

export default MenuItem;
